export enum MultigradeFormat {
  STANDARD = 'standard',
  IPLAN = 'iplan',
} 